import { Feature, Point } from 'geojson';

export interface ISnMapClusterProperties {
  objects: number;
}

export type SnMapClusterPoint = Feature<Point, ISnMapClusterProperties>;

export interface ISnMapResponse<Model> {
  results: Model[];
  clusterResults?: SnMapClusterPoint[];
  count?: number;
}
